/**
 * O processo em que a abertura cria mais um exame (E126.F4): `?processo=<id>` na URL, lido do
 * servidor para mostrar a pasta e o número; `?servico=` pré-escolhe o serviço ("Adicionar
 * contrato" chega com o do exame de onde saiu).
 */
import { useEffect, useState } from 'react';
import type { AxiosInstance } from 'axios';

import type { ServicoDaAbertura } from '@/lib/abertura';
import { lerProcesso, type ProcessoData } from '@/lib/processos';

export interface ProcessoDaAbertura {
  /** `undefined` = abertura de processo novo; `null` = ainda carregando. */
  processo: ProcessoData | null | undefined;
  erro: boolean;
  servicoInicial: ServicoDaAbertura | undefined;
}

export function servicoDaUrl(valor: string | null): ServicoDaAbertura | undefined {
  return valor === 'eletronica' || valor === 'grafotecnica' ? valor : undefined;
}

export function useProcessoDaAbertura(
  client: AxiosInstance,
  processoId: string | null,
  servico: string | null,
): ProcessoDaAbertura {
  const [processo, setProcesso] = useState<ProcessoData | null | undefined>(
    processoId === null ? undefined : null,
  );
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (processoId === null) {
      setProcesso(undefined);
      return;
    }
    let ativo = true;
    setProcesso(null);
    setErro(false);
    lerProcesso(client, processoId)
      .then((detalhe) => {
        if (ativo) setProcesso(detalhe.processo);
      })
      .catch(() => {
        if (ativo) setErro(true);
      });
    return () => {
      ativo = false;
    };
  }, [client, processoId]);

  return { processo, erro, servicoInicial: servicoDaUrl(servico) };
}
